export enum ESubIds {
  PREMIUM = 1,
  BASIC = 2,
  MASTER = 3,
  MASTERP = 4,
  BASICP = 5,
  PREMIUMP = 6,
  COLLECTOR = 10,
  VIP = 11,
}

export const subIds = [
  ESubIds.PREMIUM,
  ESubIds.BASIC,
  ESubIds.MASTER,
  ESubIds.MASTERP,
  ESubIds.BASICP,
  ESubIds.PREMIUMP,
  ESubIds.COLLECTOR,
  ESubIds.VIP,
] as const;

export type GioNode = {
  id: (typeof subIds)[number];
  name: string;
  itemsCount: number;
  bg: string;
  bg2: string;
  textColor: string;
  specialColor?: string;
};

export type GioMintedDetailType = {
  amount: number;
  blockHash: `0x${string}`;
  transactionHash: string;
  minted_at?: string;
  purchaseDate?: string;
  tokenId?: number;
  rewardedDays?: number;
  onlinePeriod?: string;
  stillOnline?: boolean;

  rewardPaymentDetail?: {
    alreadyPaid: number;
    toBePaid: number;
  };
};

export type mintedGIOsTransactionDetailsType = {
  [key: number]: GioMintedDetailType[];
};
